import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useDateDiff } from '@/composables/useDateDiff';
import { useViewerItemStore, ItemExpiresMode } from '@/modules/viewer/store/useViewerItemStore';

interface ExpiresInHumanInterface {
  expired: boolean | undefined;
  expires: ItemExpiresMode | undefined;
  dateDiffInHuman: string | undefined;
  expiresAfterViews: number | undefined;
}

const getExpiresInHuman = ({ expired, expires, dateDiffInHuman, expiresAfterViews }: ExpiresInHumanInterface) => {
  if (expired) {
    return 'expired';
  }

  if (expires === ItemExpiresMode.NEVER) {
    return 'never';
  }

  if (expires === ItemExpiresMode.SETUP && !dateDiffInHuman && !expiresAfterViews) {
    return 'never';
  }

  const labels: string[] = [];

  // DATE
  if (dateDiffInHuman && dateDiffInHuman !== '') {
    labels.push(dateDiffInHuman);
  }

  // NUMBER VIEWS
  if (expiresAfterViews && +expiresAfterViews > 0) {
    if (+expiresAfterViews == 1) {
      labels.push(`after ${expiresAfterViews} view`);
    } else {
      labels.push(`after ${expiresAfterViews} views`);
    }
  }

  return labels.join(', ');
};

export const useItemExpiration = () => {
  const viewerItemStore = useViewerItemStore();
  const { expired, expires, expiresAt, expiresAfterViews } = storeToRefs(viewerItemStore);
  const { dateDiffInHuman } = useDateDiff(expiresAt);

  const expiresInHuman = computed(() =>
    getExpiresInHuman({ expired: expired.value, expires: expires.value, dateDiffInHuman: dateDiffInHuman.value, expiresAfterViews: expiresAfterViews.value })
  );

  return { expiresInHuman };
};
